import React from "react";
import "./Resume.css";
import { Container } from "react-bootstrap";
import {
  Timeline,
  BodyContent,
  Section,
  Description,
} from "vertical-timeline-component-react";
function Education() {
  const customTheme = {
    lineColor: "#173b6c",
    dotColor: "#ffffff",
    borderDotColor: "#173b6c",
    titleColor: "#405b73",
    subtitleColor: "#bf9765",
    textColor: "#262626",
  };
  return (
    <div className="edu-bg">
      <Container>
        <div className="resume-head">
          <h3>Education</h3>
        </div>
        <div className="edu-con">
          <Timeline theme={customTheme} dateFormat="ll">
            <BodyContent>
              <Section title="King Mongkut's Institute of Technology Ladkrabang">
                <Description text="2019 - Present" />
                <Description text="Computer Engineering" />
              </Section>

              <Section title="Phatthalung School">
                <Description text="2012 - 2018" />
                <Description text="High School Diploma" />
              </Section>
            </BodyContent>
          </Timeline>
        </div>
      </Container>
    </div>
  );
}

export default Education;
